import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-maintenance-popup',
    templateUrl: './maintenance-popup.component.html',
    styleUrls: ['./maintenance-popup.component.scss']
})
export class MaintenancePopupComponent implements OnInit {
    isVisible = false;

    ngOnInit(): void {
        // Popup sẽ luôn hiện mỗi khi load trang
    }

    closePopup(): void {
        this.isVisible = false;
        // Reload trang sau khi đóng popup
        window.location.reload();
    }
}